import PageTitle from '../PageTitle';

export const HeaderSkeleton = () => {
    return (
        <div
            role="status"
            className="max-w-[1000px] animate-pulse justify-center mx-auto mb-8"
        >
            <div className="flex justify-between mb-4 mt-4">
                <div className="h-12 bg-gray-50 rounded-lg dark:bg-gray-100 w-60 items-center justify-center flex">
                    Loading...
                </div>
                <div className="flex">
                    <div className="h-12 bg-gray-50 rounded-lg dark:bg-gray-100 mx-auto w-8 flex justify-center items-center text-gray-400 mr-4" />
                    <div className="h-12 bg-gray-50 rounded-lg dark:bg-gray-100 mx-auto w-8"></div>
                </div>
            </div>

            <div className="flex justify-between mb-4 mt-8">
                <div className="h-8 bg-gray-50 rounded-lg dark:bg-gray-100 w-20"></div>
                <div className="h-8 bg-gray-50 rounded-lg dark:bg-gray-100 w-20"></div>
                <div className="h-8 bg-gray-50 rounded-lg dark:bg-gray-100 w-20"></div>
                <div className="h-8 bg-gray-50 rounded-lg dark:bg-gray-100 w-20"></div>
                <div className="h-8 bg-gray-50 rounded-lg dark:bg-gray-100 w-20"></div>
                <div className="h-8 bg-gray-50 rounded-lg dark:bg-gray-100 w-20"></div>
            </div>

            <span className="sr-only">Loading...</span>
        </div>
    );
};

export const LogoSkeleton = () => {
    return (
        <div
            role="status"
            className="max-w-xl animate-pulse justify-center mx-auto mb-2"
        >
            <div className="flex justify-between mb-4 mt-4">
                <div className="h-12 bg-gray-50 rounded-lg dark:bg-gray-100 mx-auto w-12 "></div>
                <div className="h-12 bg-gray-50 rounded-lg dark:bg-gray-100 mx-auto w-1/2 flex justify-center items-center text-gray-400">
                    Loading...
                </div>
                <div className="h-12 bg-gray-50 rounded-lg dark:bg-gray-100 mx-auto w-20"></div>
            </div>

            <span className="sr-only">Loading...</span>
        </div>
    );
};

export const PhotoFeatureBlockSkeleton = () => {
    return (
        <div
            role="status"
            className="w-full animate-pulse justify-center mx-auto mb-12"
        >
            <div className="mr-auto h-48 bg-gray-50 rounded-lg dark:bg-gray-100 w-3/4 mb-8 flex justify-center items-center text-gray-400">
                Loading...
            </div>
            <div className="ml-auto h-72 bg-gray-50 rounded-lg dark:bg-gray-100 w-3/4 mb-8 flex justify-center items-center text-gray-400">
                Loading...
            </div>
            <div className="mr-auto h-48 bg-gray-50 rounded-lg dark:bg-gray-100 w-3/4 mb-8 flex justify-center items-center text-gray-400">
                Loading...
            </div>

            <span className="sr-only">Loading...</span>
        </div>
    );
};

export const CarsVansSkeleton = () => {
    return (
        <div
            role="status"
            className="animate-pulse justify-center mx-auto w-full max-w-[1100px]"
        >
            <div className="w-full mb-4 justify-between flex flex-wrap p-2">
                <div className="basis-full sm:basis-1/2 lg:basis-1/3 pt-0 p-2">
                    <div className="h-[570px] bg-gray-50 rounded-lg dark:bg-gray-100 mx-auto w-full mb-4 flex justify-center items-center text-gray-400">
                        Loading...
                    </div>
                </div>
                <div className="basis-full sm:basis-1/2 lg:basis-1/3 pt-0 p-2">
                    <div className="h-[570px] bg-gray-50 rounded-lg dark:bg-gray-100 mx-auto w-full mb-4 flex justify-center items-center text-gray-400">
                        Loading...
                    </div>
                </div>
                <div className="basis-full sm:basis-1/2 lg:basis-1/3 pt-0 p-2">
                    <div className="h-[570px] bg-gray-50 rounded-lg dark:bg-gray-100 mx-auto w-full mb-4 flex justify-center items-center text-gray-400">
                        Loading...
                    </div>
                </div>
            </div>

            <span className="sr-only">Loading...</span>
        </div>
    );
};

export const IconFeatureBlockSkeleton = () => {
    return (
        <div
            role="status"
            className="animate-pulse justify-center mx-auto w-full max-w-[1100px]"
        >
            <div className="w-full mb-4 justify-between flex flex-wrap p-2">
                <div className="basis-full sm:basis-1/2 lg:basis-1/3 pt-0 p-2">
                    <div className="h-80 bg-gray-50 rounded-lg dark:bg-gray-100 mx-auto w-full mb-4 flex justify-center items-center text-gray-400">
                        Loading...
                    </div>
                </div>
                <div className="basis-full sm:basis-1/2 lg:basis-1/3 pt-0 p-2">
                    <div className="h-80 bg-gray-50 rounded-lg dark:bg-gray-100 mx-auto w-full mb-4 flex justify-center items-center text-gray-400">
                        Loading...
                    </div>
                </div>
                <div className="basis-full sm:basis-1/2 lg:basis-1/3 pt-0 p-2">
                    <div className="h-80 bg-gray-50 rounded-lg dark:bg-gray-100 mx-auto w-full mb-4 flex justify-center items-center text-gray-400">
                        Loading...
                    </div>
                </div>
            </div>

            <span className="sr-only">Loading...</span>
        </div>
    );
};

export const OpeningTimesSkeleton = () => {
    return (
        <div
            role="status"
            className="max-w-xs animate-pulse justify-center mx-auto"
        >
            <div className="h-8 bg-gray-50 rounded-full dark:bg-gray-100 mx-auto w-48 mb-4 mt-8 flex justify-center items-center text-gray-400">
                Loading...
            </div>
            <div className="h-4 bg-gray-50 rounded-full dark:bg-gray-100 mx-auto w-60 mb-2"></div>
            <div className="h-4 bg-gray-50 rounded-full dark:bg-gray-100 mx-auto w-55 mb-2"></div>
            <div className="h-4 bg-gray-50 rounded-full dark:bg-gray-100 mx-auto w-48 mb-2"></div>

            <span className="sr-only">Loading...</span>
        </div>
    );
};

export const HireConditionsSkeleton = () => {
    return (
        <>
            <PageTitle
                title="Conditions"
                subtitle="Terms & Conditions for Penny Car Hire"
            />
            <div
                role="status"
                className="max-w-[1100px] animate-pulse justify-center mx-auto mb-8"
            >
                <div className="h-96 bg-gray-50 rounded-xl dark:bg-gray-100 mx-auto w-full mb-4 mt-8 flex justify-center items-center text-gray-400">
                    Loading...
                </div>
                <span className="sr-only">Loading...</span>
            </div>
        </>
    );
};

export const FormSkeleton = () => {
    return (
        <div
            role="status"
            className="max-w-[1100px] w-full animate-pulse justify-center mx-auto mb-8"
        >
            <div className="h-[540px] bg-gray-50 rounded-xl dark:bg-gray-100 mx-auto w-full mb-4 mt-8 flex justify-center items-center text-gray-400">
                Loading...
            </div>
            <span className="sr-only">Loading...</span>
        </div>
    );
};

export const CompanyDetailsSkeleton = () => {
    return (
        <div className="w-full animate-pulse justify-center mx-auto">
            <div className="flex flex-wrap mb-4 gap-4 sm:flex-nowrap md:flex-wrap">
                <div className="w-full sm:w-1/2 md:w-full flex flex-wrap bg-gray-50 p-2 h-28 rounded-xl justify-center items-center">
                    Loading...
                </div>
                <div className="w-full sm:w-1/2 md:w-full flex flex-wrap bg-gray-50 p-2 h-28 rounded-xl justify-center items-center">
                    Loading...
                </div>
            </div>
            <div className="flex flex-wrap">
                <div className="w-full flex flex-wrap bg-gray-50 p-2 h-28 rounded-xl justify-center items-center">
                    Loading...
                </div>
            </div>
        </div>
    );
};

export const QuoteFormTopSkeleton = () => {
    return (
        <div
            role="status"
            className="w-full animate-pulse justify-center mx-auto mb-4"
        >
            <div className="h-2 bg-gray-50 rounded-xl dark:bg-gray-100 mx-auto w-full mb-8 flex justify-center items-center text-gray-400" />
            <div className="h-2 bg-gray-50 rounded-xl dark:bg-gray-100 mx-auto w-full mb-2 mt-2 flex justify-center items-center text-gray-400" />
            <div className="h-12 bg-gray-50 rounded-xl dark:bg-gray-100 mx-auto w-full mb-2 mt-2 flex justify-center items-center text-gray-400">
                Loading...
            </div>
            <div className="h-2 bg-gray-50 rounded-xl dark:bg-gray-100 mx-auto w-full mt-2 flex justify-center items-center text-gray-400" />
            <span className="sr-only">Loading...</span>
        </div>
    );
};

export const WhatsAppCallButtonsSkeleton = () => {
    return (
        <div
            role="status"
            className="w-full animate-pulse justify-center mx-auto mb-4"
        >
            <div className="h-12 bg-gray-50 rounded-xl dark:bg-gray-100 mx-auto w-full mb-2 mt-2 flex justify-center items-center text-gray-400">
                Loading...
            </div>
            <div className="h-12 bg-gray-50 rounded-xl dark:bg-gray-100 mx-auto w-full mb-2 mt-2 flex justify-center items-center text-gray-400">
                Loading...
            </div>
            <span className="sr-only">Loading...</span>
        </div>
    );
};
